import * as React from 'react';
import styled from 'styled-components';
import * as _ from 'lodash/fp';

import { Checkbox } from '@process-advisor/process-miner/components/shared/checkbox';
import { type ShowColorsProps } from '@process-advisor/process-miner/api/methods/time/changeShowColors';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

const Wrapper = styled.div`
`;

export const ShowColors = () => {
    const [ShowColors, setShowColors] = React.useState<ShowColorsProps>({});
    const onChange = _.curry((
        key: keyof ShowColorsProps,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const newShowColors = { ...ShowColors, [key]: e.target.checked };
        setShowColors(newShowColors);
        apiProvider.changeShowColors(newShowColors);
    });

    React.useEffect(() => {
        setShowColors(apiProvider.getShowColors());
    }, []);

    React.useEffect(() => {
        const listener = () =>
            setShowColors(apiProvider.getShowColors());
        listener();

        apiProvider.on(Event.loadProcessMinerSettings, listener);

        return () => {
            apiProvider.off(Event.loadProcessMinerSettings, listener);
        };
    }, []);

    return (
        <Wrapper>
            <Checkbox
                label=''
                checked={!!ShowColors.visible}
                handleOnChange={onChange('visible')} />
        </Wrapper>
    );
};
